<template>
  <div>
   <v-container fill-height>
      <v-layout
        justify-center
        align-center
        wrap
      >
        <v-flex mb-12>
          <iframe style="margin: 0 12em" width="800" height="450" src="https://www.youtube.com/embed/oVHHjs-BmGE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </v-flex>
        <v-flex
          tag="h2"
          display-1
          text-xs-center
          mb-5
          v-text="$t('Home.platformHeader')"
        />

        <v-flex
          xs12
          mb-5
        >
          <alpha-card-feature :features="cardFeatures" />
        </v-flex>

        <!--<v-flex
          xs12
          mb-5
        >
          <alpha-list-feature :features="listFeatures" />
        </v-flex>-->
      </v-layout>
    </v-container>

    <!--<alpha-hero
      :height="$vuetify.breakpoint.mdAndUp ? 500 : 'auto'"
      :jumbotron="false"
      :items="items"
      gradient="to top, rgba(0, 0, 0, .75), rgba(0, 0, 0, .75)"
      dark
      class="py-5"
    >
      <v-container
        fill-height
        grid-list-xl
      >
        <v-layout
          align-center
          justify-space-around
          wrap
        >
          <v-flex
            v-for="(testimonial, i) in testimonials"
            :key="i"
            xs12
            sm5
          >
            <alpha-testimonial
              :author="testimonial.author"
              :title="testimonial.title"
              :quote="testimonial.quote"
              dark
            />
          </v-flex>
        </v-layout>
      </v-container>
    </alpha-hero>-->
  </div>
</template>

<script>
  export default {
    metaInfo () {
      return {
        title: this.$i18n.t('Home.jumbotronTitle')
      }
    },

    data: () => ({
      items: ['/static/server-parallax.png']
    }),

    computed: {
      cardFeatures () {
        return this.$t('Home.cardFeatures')
      },
      listFeatures () {
        return this.$t('Home.listFeatures')
      },
      testimonials () {
        return this.$t('Home.testimonials')
      }
    }
  }
</script>
